import { tryOnScopeDispose } from '@vueuse/core';
import { useDevLogger } from '@/composables/useDevLogger';

export function supportsCloseWatcher (): boolean {
  return 'CloseWatcher' in window;
}

export function useCloseWatcher ({
  onCancel = () => {},
  onClose = () => {},
}: {
  onCancel?: (event: Event) => void;
  onClose?: (event: Event) => void;
} = {}) {
  const { log, warn } = useDevLogger();

  let closeWatcher: CloseWatcher | null = null;

  if (!supportsCloseWatcher()) {
    warn('CloseWatcher is not supported in this environment');
    return () => {};
  }

  closeWatcher = new CloseWatcher();

  closeWatcher.addEventListener('cancel', (event) => {
    log('[useCloseWatcher] onCancel');
    onCancel?.(event);
  });

  closeWatcher.addEventListener('close', (event) => {
    log('[useCloseWatcher] onClose');
    onClose?.(event);
  });

  function cleanupFn () {
    log('[useCloseWatcher] Destroying');
    closeWatcher?.destroy();
    closeWatcher = null;
  }

  tryOnScopeDispose(() => {
    cleanupFn();
  });

  return cleanupFn;
}
